import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import TFPAQuotePage from "tfpa-capability-quoteandbind-residential-react/pages/Quote/QuotePage.jsx";
import TFPAEffectiveDatePage from './pages/EffectiveDate/EffectiveDate.jsx';
import TFPAChangePolicyDetailsPage from './pages/PolicyDetails/PolicyChangeDetails.jsx';
import TFPAChangePropertyDetailsPage from './pages/PropertyDetails/PropertyDetailsPage';
import TFPAChangeConstructionPage from './pages/Construction/ConstructionPage';
import TFPAChangeAdditionalInformationPage from './pages/AdditionalInformation/AdditionalInformationPage';
import TFPAChangeCoverageSummaryPage from './pages/CoverageSummary/CoverageSummaryPage';
import TFPAChangePaymentDetailsPage from './pages/PaymentDetails/PaymentDetailsPage';
import TFPAChangeDiscountsPage from './pages/Discounts/DiscountsPage';

setComponentMapOverrides(
    {
        TFPAEffectiveDatePage:  { component: 'TFPAEffectiveDatePage' },
        TFPAChangePolicyDetailsPage: { component: 'TFPAChangePolicyDetailsPage' },
        TFPAChangePropertyDetailsPage: { component: 'TFPAChangePropertyDetailsPage' },
        TFPAChangeConstructionPage: { component: 'TFPAChangeConstructionPage' },
        TFPAChangeQuotePage: { component: 'TFPAChangeQuotePage' },
        TFPAChangeAdditionalInformationPage: { component: 'TFPAChangeAdditionalInformationPage' },
        TFPAChangeCoverageSummaryPage: { component: 'TFPAChangeCoverageSummaryPage' },
        TFPAChangePaymentDetailsPage: { component: 'TFPAChangePaymentDetailsPage' },
        TFPAChangeDiscountsPage: {component: 'TFPAChangeDiscountsPage'},
    },
    {
        TFPAEffectiveDatePage,
        TFPAChangePolicyDetailsPage,
        TFPAChangePropertyDetailsPage,
        TFPAChangeConstructionPage,
        TFPAChangeQuotePage: TFPAQuotePage,
        TFPAChangeAdditionalInformationPage,
        TFPAChangeCoverageSummaryPage,
        TFPAChangePaymentDetailsPage,
        TFPAChangeDiscountsPage,
    }
);


export { default as TFPAChangeResidentialWizard } from './TFPAChangeResidentialWizard.jsx';
export { default as TWIAAccountHolderEdit } from './components/TWIAAccountHolderEdit/TWIAAccountHolderEdit.jsx';
